import { createTheme } from "@mui/material/styles";

export const primary = {
  light: "#c2fffd",
  main: "#005cff",
  dark: "#00398c",
  contrastText: "#fbfbfb",
};
const secondary = {
  main: "#005cff",
  light: "#ccc",
  dark: "#000000",
  contrastText: "#fbfbfb",
};

// Background colors - centralized for consistency with blue tints
export const backgrounds = {
  page: "#f5f5f5",          // Main page background
  surface: "#f0f6ff",       // Cards, panels, lighter surfaces - subtle blue
  paper: "#ffffff",         // Paper/card background
  hover: "#dce8fc",         // Hover states - blue tint
  sectionHeader: "#e3ecfa", // Section headers background
};

// Border colors with blue tints
export const borders = {
  light: "#c5d5eb",         // Light border - blue tint
  main: "#a8c4e8",          // Main border - more blue
  accent: "#005cff",        // Accent border - primary blue
};

// Table-specific colors
export const tableColors = {
  headerBackground: "#dce8fc",  // Slightly darker blue for headers
  rowEven: backgrounds.paper,
  rowOdd: "#f5f9ff",            // Very light blue for alternating rows
  rowHover: "#cce0ff",          // Blue hover
  rowSelected: "#4a90d9",       // Dark blue selected state
  border: borders.light,
};

const theme = createTheme({
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderColor: borders.light,
        },
        outlined: {
          borderColor: borders.light,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        outlined: {
          borderColor: borders.main,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: tableColors.headerBackground,
          "& .MuiTableCell-head": {
            fontWeight: 600,
            color: "#424242",
            borderBottom: `2px solid ${tableColors.border}`,
          },
        },
      },
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          "& .MuiTableRow-root": {
            "&:nth-of-type(odd)": {
              backgroundColor: tableColors.rowOdd,
            },
            "&:nth-of-type(even)": {
              backgroundColor: tableColors.rowEven,
            },
            "&:hover": {
              backgroundColor: tableColors.rowHover,
            },
            "&.Mui-selected, &.Mui-selected:hover": {
              backgroundColor: primary.light,
            },
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: "12px 16px",
          borderBottom: `1px solid ${tableColors.border}`,
        },
        head: {
          padding: "14px 16px",
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          transition: "background-color 0.15s ease-in-out",
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected, &.Mui-selected:hover": {
            backgroundColor: secondary.main,
          },
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: backgrounds.hover,
          },
        },
      },
    },
  },
  palette: {
    primary,
    secondary,
  },
  typography: {},
});

export default theme;
